const LOGIN_REQUEST = 'LOGIN_REQUEST';
const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
const LOGIN_FAILURE = 'LOGIN_FAILURE';
const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';

const NETWORK_ONLINE = 'NETWORK_ONLINE';
const NETWORK_OFFLINE = 'NETWORK_OFFLINE';

const BREADCRUMB_LEAF_NAME_CHANGE = 'BREADCRUMB_LEAF_NAME_CHANGE';

const VENUE_SELECTED = 'VENUE_SELECTED';

export {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  NETWORK_ONLINE,
  NETWORK_OFFLINE,
  BREADCRUMB_LEAF_NAME_CHANGE,
  VENUE_SELECTED,
};



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js